import template from './facility-row.html';

const FacilityRowComponent = {
    bindings: {
        facility: '<',
    },
    template
};

export default FacilityRowComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/facility-row/facility-row-component.js